import React, { useEffect } from "react";
import { useTranslation } from "react-i18next"
import { CustomTable, MobileTable, SimpleLoader, SimplePopoverPlainOption } from "@dev/ee-components";
import { useDispatch, useSelector } from "react-redux";
import { GetCampaigns, getCampaignsStore, SetCampaignCreatorOpen, UnpickAllCampaigns } from "@/store/campaigns/actions";
import useMobile from "@/services/hooks/useMobile";
import { Campaign } from "@dev/ee-api/ee-api-models";
import { EmptyState } from "../EmptyState";
import { EmptyStateContainer, TableContainer } from "./styles";
import { columnsWidth, defaultParams } from "./config";
import { useTableHeaders } from "./hooks/useTableHeaders";
import { useTableRows } from "./hooks/useTableRows";
import { useMobileTableHeaders } from "./hooks/useMobileTableHeaders";
import { useMobileTableRows } from "./hooks/useMobileTableRows";
import { getDropdownTableOptions } from "./functions/getDropdownTableOptions";
import { useDropdownAction } from "./hooks/useDropdownAction";

export const CampaignsWidgetContent = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobile = useMobile();

    const headers = useTableHeaders();
    const mobileHeaders = useMobileTableHeaders();
    const campaigns = useSelector(getCampaignsStore);
    const rows = useTableRows(campaigns);
    const mobileRows = useMobileTableRows(campaigns);
    const { getDropdownAction } = useDropdownAction();

    useEffect(() => {
        dispatch(GetCampaigns({
            ...defaultParams,
        }));

        return (): void => {
            dispatch(UnpickAllCampaigns());
        };
    }, []);

    const handleCreateCampaignClick = () => {
        dispatch(SetCampaignCreatorOpen(true));
    }

    if (campaigns?.loading) {
        return <SimpleLoader />;
    }

    if (campaigns?.collection?.length === 0) {
        return (
            <EmptyStateContainer>
                <EmptyState
                    title={t('home_campaignsemptystate_title')}
                    description={t('home_campaignsemptystate_description')}
                    button={{
                        text: t('home_campaignsemptystate_button'),
                        onClick: handleCreateCampaignClick
                    }}
                />
            </EmptyStateContainer>
        );
    }

    if (isMobile) {
        return (
            <MobileTable
                headers={mobileHeaders}
                rows={mobileRows}
                dropdownDataFilter={(options, rowData) => getDropdownTableOptions(rowData as Campaign)}
                onItemClick={(e, option, rowData) => { getDropdownAction(e, option as SimplePopoverPlainOption, rowData)} }
            />
        );
    }

    return (
        <TableContainer>
            <CustomTable
                headers={headers}
                rows={rows}
                emptyRowsNo={3}
                disableFirstRowBorderTop
                disableRowClick
                disableRowHover
                hideCheckboxes
                columnsWidth={columnsWidth}
                rowPadding={0}
                tableCellPadding="8px 16px 8px 0"
            />
        </TableContainer>
    );
};
